"use client";

import React, { Suspense, useEffect } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store";
import ErrorBoundary from "@/components/common/ErrorBoundary";
import { initializeApiClient } from "@/lib/apiClient";

// Loading component for PersistGate
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
  </div>
);

// Component to initialize API client after store is ready
const ApiClientInitializer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useEffect(() => {
    // Initialize API client with store getter
    initializeApiClient(() => store.getState());
  }, []);

  return <>{children}</>;
};

export const ReduxProviders: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={<LoadingFallback />} persistor={persistor}>
          <ApiClientInitializer>
            <Suspense fallback={<LoadingFallback />}>{children}</Suspense>
          </ApiClientInitializer>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
};

export default ReduxProviders;
